import React, { useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaBook,
  FaProjectDiagram,
  FaUserCog,
  FaWarehouse,
  FaSignOutAlt,
  FaBookReader,
  FaShoppingCart,
  FaCashRegister,
  FaClipboard,
} from "react-icons/fa";
import { handleLogout } from "../constants/logoutHelper";

const Sidebar = ({
  collapsed,
  toggled,
  handleToggleSidebar,
  handleCollapsedChange,
}) => {
  const { user, setting, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  const logoutButtonHandler = async (e) => {
    e.preventDefault();
    handleLogout(dispatch, navigate);
  };

  return (
    <ProSidebar
      collapsed={collapsed}
      toggled={toggled}
      onToggle={handleToggleSidebar}
      breakPoint="md"
    >
      {/* Header */}
      <SidebarHeader>
        <Menu iconShape="circle">
          {collapsed ? (
            <MenuItem
              icon={<FaAngleDoubleRight />}
              onClick={handleCollapsedChange}
            ></MenuItem>
          ) : (
            <MenuItem
              suffix={<FaAngleDoubleLeft />}
              onClick={handleCollapsedChange}
            >
              <div
                style={{
                  padding: "9px",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  fontSize: 15,
                  letterSpacing: "1px",
                }}
              >
                {setting.namaProgram} {setting.namaJenisProgram}
              </div>
            </MenuItem>
          )}
        </Menu>
      </SidebarHeader>
      {/* Content */}
      <SidebarContent>
        <Menu iconShape="circle">
          <SubMenu title={"Master"} icon={<FaBook />}>
            {user.akses.arsitek === true && (
              <MenuItem>
                Arsitek <NavLink to="/arsitek" />
              </MenuItem>
            )}
            {user.akses.cabang === true && (
              <MenuItem>
                Cabang <NavLink to="/cabang" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu title={"Proyek"} icon={<FaProjectDiagram />}>
            <SubMenu title={"Transaksi"}>
              {user.akses.customer === true && (
                <MenuItem>
                  Customer <NavLink to="/customer" />
                </MenuItem>
              )}
              {user.akses.proyek === true && (
                <MenuItem>
                  Proyek <NavLink to="/daftarProyek" />
                </MenuItem>
              )}
            </SubMenu>
            <SubMenu title={"Laporan"}>
              {user.akses.lapProyekSemua === true && (
                <MenuItem>
                  Proyek Semua <NavLink to="/lapProyekSemua" />
                </MenuItem>
              )}
              {user.akses.lapProyekMenunggu === true && (
                <MenuItem>
                  Proyek Menunggu <NavLink to="/lapProyekMenunggu" />
                </MenuItem>
              )}
            </SubMenu>
            {/* {user.akses.rab === true && (
              <MenuItem>
                RAB <NavLink to="/daftarRab" />
              </MenuItem>
            )} */}
          </SubMenu>
          {/* <SubMenu title={"Arsitek"} icon={<FaBookReader />}>
            {user.akses.kirimGambar === true && (
              <MenuItem>
                Kirim Gambar <NavLink to="/daftarKirimGambar" />
              </MenuItem>
            )}
            {user.akses.revisi === true && (
              <MenuItem>
                Revisi <NavLink to="/daftarRevisi" />
              </MenuItem>
            )}
            {user.akses.preOrder === true && (
              <MenuItem>
                PO <NavLink to="/daftarPreOrder" />
              </MenuItem>
            )}
            {user.akses.produksi === true && (
              <MenuItem>
                Produksi <NavLink to="/daftarProduksi" />
              </MenuItem>
            )}
          </SubMenu> */}
          <SubMenu title={"Utility"} icon={<FaUserCog />}>
            {user.akses.profilUser === true && (
              <MenuItem>
                Profil User <NavLink to="/profilUser" />
              </MenuItem>
            )}
            {user.akses.daftarUser === true && (
              <MenuItem>
                Daftar User <NavLink to="/daftarUser" />
              </MenuItem>
            )}
            {user.akses.setting === true && (
              <MenuItem>
                Setting <NavLink to="/setting" />
              </MenuItem>
            )}
          </SubMenu>
        </Menu>
      </SidebarContent>
      {/* Footer */}
      <SidebarFooter style={{ textAlign: "center" }}>
        <p style={{ fontSize: "12px", marginTop: "10px" }}>{user.username}</p>
        <p
          style={{ fontSize: "12px", marginTop: "-10px" }}
        >{`${user.cabang.id} - ${user.cabang.namaCabang}`}</p>
        <div className="sidebar-btn-wrapper" style={{ paddingBottom: "10px" }}>
          <Link
            className="sidebar-btn"
            style={{ cursor: "pointer" }}
            to="/"
            onClick={logoutButtonHandler}
          >
            <span style={{ marginRight: "6px" }}>Logout</span>
            <FaSignOutAlt />
          </Link>
        </div>
      </SidebarFooter>
    </ProSidebar>
  );
};

export default Sidebar;
